import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { AlertTriangle } from 'lucide-react';
import api from '@/lib/api';

/**
 * Super Admin banner showing count of unresolved abuse events.
 * Silently returns null for non-super-admins or when zero unresolved.
 * Polls every 60s.
 */
export function AbuseBadge() {
  const [summary, setSummary] = useState({ unresolved: 0 });

  useEffect(() => {
    let cancelled = false;
    async function load() {
      try {
        const res = await api.get('/admin/abuse/summary');
        if (!cancelled) setSummary(res.data || { unresolved: 0 });
      } catch {
        /* silently ignore — non-super-admin will get 0 */
      }
    }
    load();
    const t = setInterval(load, 60_000);
    return () => { cancelled = true; clearInterval(t); };
  }, []);

  if (!summary.unresolved) return null;

  return (
    <Link
      to="/admin/abuse-events"
      data-testid="abuse-badge"
      className="inline-flex items-center gap-1.5 rounded-full bg-destructive/15 text-destructive px-2.5 py-1 text-xs font-semibold hover:bg-destructive/25 transition-colors"
      title={`${summary.unresolved} unresolved abuse event(s)`}
    >
      <AlertTriangle className="w-3.5 h-3.5" />
      {summary.unresolved} abuse
    </Link>
  );
}
